import { useEffect } from 'react';

import { Box } from 'ui';

import { Card } from '../../../api';
import { useTokenEx } from '../TokenEx';
import { CvvID } from '../utils';
import { useTokenize } from './useTokenize';

interface Config {
  app_id: string;
  authentication_key: string;
  scheme: string;
  timestamp: string;
}

declare global {
  interface Window {
    TokenEx: any;
  }
}

export const TokenExCVV = ({
  cardType,
  config,
  onChange,
  setIsCvvValid,
}: {
  cardType: string;
  config: Config;
  onChange?: (status: boolean) => void;
  setIsCvvValid?: (status: boolean) => void;
}) => {
  const { setSettings, isConfigAndTokenReady, initiateTokenEx, tokenizeCard, isCardValid } =
    useTokenEx({
      tokenizeOnValidate: false,
      onTokenize: (card: Partial<Card>) => {
        onChange?.(card.token ? true : false);
      },
    });
  useTokenize({ tokenizeCard });

  useEffect(() => {
    setIsCvvValid?.(isCardValid);
  }, [isCardValid]);

  useEffect(() => {
    isConfigAndTokenReady && initiateTokenEx('cvvOnly');
  }, [isConfigAndTokenReady]);

  useEffect(() => {
    if (config && cardType) {
      setSettings((prev) => ({ ...prev, config, cardType }));
    }
  }, [config, cardType]);

  return (
    <Box component="form" autoComplete="on" maw="100px" w="100%" h={45} pos="relative">
      <Box id={CvvID} pos="absolute" />
    </Box>
  );
};
